import * as React from "react";
const SvgFiberSmartRecord = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 12,
  r: 8,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 4.26v2.09a5.99 5.99 0 0 1 0 11.3v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z",
  fill: "currentColor"
}));
export default SvgFiberSmartRecord;